import { PostHogErrorBoundary } from "posthog-js/react";
import { ErrorBoundary } from "./ErrorBoundary";
import { useTrackingConsent } from "@/hooks/shared/tracking-consent/useTrackingConsent";
import { memo } from "react";

/**
 * An error boundary that uses PostHogErrorBoundary if the user has given tracking consent,
 * otherwise falls back to a standard ErrorBoundary.
 */
export const TrackedErrorBoundary = memo(({ children }: { children: React.ReactNode }) => {
    const { canTrack } = useTrackingConsent();

    if (canTrack) {
        return <PostHogErrorBoundary>{children}</PostHogErrorBoundary>;
    }

    return <ErrorBoundary>{children}</ErrorBoundary>;
});

TrackedErrorBoundary.displayName = "ConditionallyTrackedErrorBoundary";
